/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactFilter {
    getFixupPrototypeFunction() { return ArtifactFilter.fixupPrototype; }

    static newInstance(model: Partial<ArtifactFilter>): ArtifactFilter {
        let obj = Object.assign(new ArtifactFilter(), model);
        ArtifactFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactFilter>): ArtifactFilter {
        if (!model) return null;
        return ArtifactFilter.newInstance(<ArtifactFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactFilter) {
        if (!obj) return;

        models.ArtifactFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactFilter): boolean {
        Object.setPrototypeOf(obj, ArtifactFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * ID of the agent
     */
    agent_id: string;

    /**
     * Title of the artifact (substring match)
     */
    title: string;

    /**
     * Full-text search over title/description/tags
     */
    query: string;

    /**
     * List artifacts shared with the caller instead of the ones they own
     */
    shared_with_me: boolean = false;

    /**
     * Only artifacts created in this chat. Scopes the list to the open chat window, independent of who owns the artifacts.
     */
    source_chat_id: string;

    /**
     * Only artifacts created in this single conversation turn.
     */
    source_conversation_id: string;

}
